import { graphql } from 'react-relay';
import commitMutation from 'relay-commit-mutation-promise';
import { ConnectionHandler } from 'relay-runtime';

const mutation = graphql`
    mutation cartItemRemoveMutation($input: ModifyPortfolioItemsInput!) {
        modifyPortfolioItems(input: $input) {
            removedItemIds
            portfolio {
                items {
                    totalResults
                }
            }
        }
    }
`;

// Removes the deleted portfolio item from the relay store,
// so it can be updated without refetching
function cartRemoveItemUpdater({ store, viewerId, userId, portfolioItemRelayId }) {
    const viewer = store.get(viewerId);
    const portfolios = viewer.getLinkedRecord('portfolios', {
        first: 1,
        portfolioTypes: ['CART'],
        userIds: [userId],
    });
    const portfoliosEdge = portfolios.getLinkedRecords('edges')[0];
    if (!portfoliosEdge) {
        return;
    }
    const cartPortfolio = portfoliosEdge.getLinkedRecord('node');
    const cartPortfolioConnection = ConnectionHandler.getConnection(
        cartPortfolio,
        'CartItemList_items'
    );

    // remove portfolio item from the connection
    ConnectionHandler.deleteNode(cartPortfolioConnection, portfolioItemRelayId);

    // decrement totalResults
    cartPortfolioConnection.setValue(
        'totalResults',
        cartPortfolioConnection.getValue('totalResults') - 1
    );
}

export function cartItemRemoveMutation(environment, args) {
    const { viewerId, userId, portfolioId, portfolioItemId, portfolioItemRelayId } = args;

    const input = {
        action: 'REMOVE',
        userId,
        portfolioId,
        portfolioItemsIds: [portfolioItemId],
    };

    return commitMutation(environment, {
        mutation,
        variables: { input },
        updater: store => cartRemoveItemUpdater({ store, viewerId, userId, portfolioItemRelayId }),
        optimisticUpdater: store =>
            cartRemoveItemUpdater({ store, viewerId, userId, portfolioItemRelayId }),
    });
}
